import BaseResource from './BaseResource'

export default class ItemConfigurations extends BaseResource {
  static endpoint = '/api/v1/itemConfigurations' ///tracking
}
